import React, { useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import { Button, Badge } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { HiOutlineTrash } from "react-icons/hi";
import { FiEdit2 } from "react-icons/fi";
import axios, { get } from "axios";
import { ToastContainer, toast } from "react-toastify";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import config from "../../../../config";
import Breadcrumbs from "../../../Helper/Breadcrumbs";

const BlogAuthorsTable = () => {
  const history = useHistory();
  const tokenKey = {
    headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
  };
  const breadcrumbData = [
    { title: "seobook", href: "/seobook" },
    { title: "Blog Authors", href: "#" },
  ];
  const toastAttr = {
    theme: "colored",
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  const [tableData, setTableData] = useState([]);

  const fetchAuthors = () => {
    get(config.service + "/masters/blog-authors/", tokenKey)
      .then((res) => setTableData(res.data))
      .catch((err) => {
        if (err.response?.status === 401) window.location.href = "/";
      });
  };

  useEffect(() => {
    fetchAuthors();
  }, []);

  const deleteRow = (row) => {
    if (window.confirm("Are you sure you want to delete this author?")) {
      axios
        .delete(
          config.service + "/masters/blog-authors/" + row.id + "/",
          tokenKey
        )
        .then(() => {
          toast.success("Deleted successfully", toastAttr);
          fetchAuthors();
        })
        .catch(() => toast.error("Deletion Failed", toastAttr));
    }
  };

  const renderForm = (row) => {
    history.push({
      pathname: "/seobook/blogAuthorsform",
      state: row ? { id: row.id, editMode: true } : {},
    });
  };

  const cols = [
    {
      dataField: "profile_image",
      text: "Photo",
      headerStyle: { width: "80px" },
      formatter: (cell) =>
        cell ? (
          <img
            src={cell}
            alt="Author"
            className="rounded-circle"
            style={{ width: "40px", height: "40px", objectFit: "cover" }}
          />
        ) : (
          <div
            className="rounded-circle bg-light d-flex align-items-center justify-content-center"
            style={{ width: "40px", height: "40px" }}
          >
            —
          </div>
        ),
    },
    {
      dataField: "name",
      text: "Name",
      headerStyle: { width: "220px" },
    },
    {
      dataField: "designation",
      text: "Designation",
      headerStyle: { width: "250px" },
    },
    {
      dataField: "is_active",
      text: "Status",
      headerStyle: { width: "120px" },
      formatter: (cell) => (
        <Badge bg={cell ? "success" : "secondary"}>
          {cell ? "Active" : "Inactive"}
        </Badge>
      ),
    },
    {
      dataField: "id",
      text: "Actions",
      headerStyle: { width: "120px" },
      formatter: (cell, row) => (
        <div className="tableActions">
          <FiEdit2 title="Edit" onClick={() => renderForm(row)} />
          <HiOutlineTrash title="Delete" onClick={() => deleteRow(row)} />
        </div>
      ),
    },
  ];

  const rowEvents = {
    onClick: (e, row) => renderForm(row),
  };

  const options = paginationFactory({
    sizePerPage: 20,
    paginationSize: 3,
    hideSizePerPage: true,
    totalSize: tableData.length,
    hidePageListOnlyOnePage: true,
  });

  return (
    <Container>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <div className="card__title pageNav">
                <div className="bold-text">
                  <Breadcrumbs data={breadcrumbData} />
                </div>
              </div>
              <div className="formBtnsDiv mb-3">
                <Button variant="primary" onClick={() => renderForm()}>
                  Create Author
                </Button>
              </div>
              <BootstrapTable
                bootstrap4
                wrapperClasses="table-responsive"
                keyField="id"
                data={tableData}
                columns={cols}
                rowEvents={rowEvents}
                hover
                noDataIndication="No authors found"
                pagination={options}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <ToastContainer {...toastAttr} />
    </Container>
  );
};

export default BlogAuthorsTable;
